/**
 * Launcher build-time constants. Centralised so the env reads happen
 * once and the rest of the launcher uses plain consts.
 */
import { ANY_ORIGIN } from '@/shared/protocol';

export const CHATBOT_CONFIG_PATH = '/chat-bot/config';
/** Hard cap on the config fetch so a slow BE never blocks the bubble. */
export const CONFIG_FETCH_TIMEOUT_MS = 5_000;
/** Window in which the SPA must signal WIDGET_READY after mount. */
export const WIDGET_READY_TIMEOUT_MS = 10_000;
/**
 * Soft warning threshold: once the iframe is REVEALED, the hard
 * WIDGET_READY_TIMEOUT_MS teardown is disarmed (users mid-conversation
 * shouldn't lose their widget to a slow SPA). This soft timer stays armed
 * to surface a console warning for integrators debugging a stuck SPA.
 */
export const WIDGET_READY_WARN_MS = 15_000;

// Empty string is treated the same as unset — a deploy pipeline that
// passes `CIRCUIT_EMBED_ORIGIN=` with no value would otherwise sneak past
// the production guard and break the postMessage handshake silently.
const RAW_EMBED_ORIGIN = import.meta.env.CIRCUIT_EMBED_ORIGIN;
export const EMBED_ORIGIN =
  RAW_EMBED_ORIGIN === undefined || RAW_EMBED_ORIGIN === ''
    ? ANY_ORIGIN
    : RAW_EMBED_ORIGIN;

/**
 * `'*'` in production would expose the iframe to any origin's
 * postMessages, defeating host isolation. Dev tolerates the missing var.
 */
export function assertOriginConfigured(): void {
  if (import.meta.env.PROD && EMBED_ORIGIN === ANY_ORIGIN) {
    throw new Error(
      '[circuit-chat-embed] CIRCUIT_EMBED_ORIGIN is required in production builds. ' +
        'Set it in the deploy pipeline (see .env.example).',
    );
  }
}

/** Accept an inbound message if EMBED_ORIGIN is `'*'` (dev) or matches. */
export function isAllowedOrigin(eventOrigin: string): boolean {
  return EMBED_ORIGIN === ANY_ORIGIN || eventOrigin === EMBED_ORIGIN;
}
